// Icon Registry - Tree-shakable icon imports
// Only includes icons that are actually used in the codebase

import {
  // Navigation & UI
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ArrowDownRight,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Menu,
  MoreHorizontal,
  PanelLeft,
  ScrollIcon,
  LayoutDashboard,
  Info,
  ClipboardList,
  Trophy,
  
  // Actions & Operations
  Check,
  CheckCircle,
  CheckCircle2,
  X,
  Plus,
  Edit,
  Trash2,
  Upload,
  Search,
  Settings,
  
  // Status & Alerts
  AlertCircle,
  AlertTriangle,
  XCircle,
  Clock,
  HelpCircle,
  Activity,
  
  // Business & Finance
  CreditCard,
  DollarSign,
  IndianRupee,
  
  // Communication
  Mail,
  Phone,
  MessageSquare,
  Bell,
  
  // User & People
  User,
  Users,
  UserCheck,
  UserX,
  Crown,
  
  // Security & Auth
  Lock,
  Shield,
  Eye,
  EyeOff,
  
  // Business & Industry
  Building,
  Building2,
  Briefcase,
  Factory,
  FlaskConical,
  Fuel,
  Globe,
  MapPin,
  
  // Analytics & Charts
  BarChart3,
  TrendingUp,
  Target,
  FileText,
  ClipboardCheck,
  History,
  Calendar,
  
  // Tech & Features
  Zap,
  Chrome,
  Award,
  Loader2,
  
  // UI Components (from existing UI components)
  Circle,
  Dot,
  GripVertical,
  
  type LucideIcon
} from 'lucide-react';

// Icon Registry - Maps icon names to components for tree-shaking
export const iconRegistry = {
  // Navigation & UI
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ArrowDownRight,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Menu,
  MoreHorizontal,
  PanelLeft,
  ScrollIcon,
  LayoutDashboard,
  Info,
  ClipboardList,
  Trophy,
  
  // Actions & Operations
  Check,
  CheckCircle,
  CheckCircle2,
  X,
  Plus,
  Edit,
  Trash2,
  Upload,
  Search,
  Settings,
  
  // Status & Alerts
  AlertCircle,
  AlertTriangle,
  XCircle,
  Clock,
  HelpCircle,
  Activity,
  
  // Business & Finance
  CreditCard,
  DollarSign,
  IndianRupee,
  
  // Communication
  Mail,
  Phone,
  MessageSquare,
  Bell,
  
  // User & People
  User,
  Users,
  UserCheck,
  UserX,
  Crown,
  
  // Security & Auth
  Lock,
  Shield,
  Eye,
  EyeOff,
  
  // Business & Industry
  Building,
  Building2,
  Briefcase,
  Factory,
  FlaskConical,
  Fuel,
  Globe,
  MapPin,
  
  // Analytics & Charts
  BarChart3,
  TrendingUp,
  Target,
  FileText,
  ClipboardCheck,
  History,
  Calendar,
  
  // Tech & Features
  Zap,
  Chrome,
  Award,
  Loader2,
  
  // UI Components
  Circle,
  Dot,
  GripVertical,
} as const;

// Type for available icon names
export type IconName = keyof typeof iconRegistry;

// Helper to get icon component by name
export const getIcon = (name: IconName): LucideIcon => {
  return iconRegistry[name];
};

// Export LucideIcon type for use in components
export type { LucideIcon };

// Social Media Icons (separate export for Footer component)
export {
  Facebook,
  Twitter,
  Linkedin,
  Instagram
} from 'lucide-react';